import { useState } from 'react';
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    InputAdornment,
    Link,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL;
const FIXED_AMOUNT = 25350;

export default function AlertBox({ userId, project, setDrawer }) {
    const [amount, setAmount] = useState(FIXED_AMOUNT);
    const [paymentUrl, setPaymentUrl] = useState(null);
    
    const [loading, setLoading] = useState(false);

    const handlePayment = async (_amount) => {
        try {
            setLoading(true);

            const response = await axios.post(
                `${API_URL}/paystack/payment-url`,
                {
                    username: project.username,
                    email: project.email,
                    amount: _amount,
                    user_id: userId,
                    project_id: project.id
                }
            );

            if (response.data) {
                setPaymentUrl(response.data);
                window.open(response.data, '_blank');
            } else {
                toast.error('an error occured');
            }

            
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {project.status === 'CREATED' && project.amount_paid === 0 && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                    <Typography variant="h6" gutterBottom>
                        Project Not Started
                    </Typography>
                    <Typography variant="body1" mb={2}>
                        To start this project, you must complete payment or deposit a minimum of half the fee.
                    </Typography>

                   

                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                        <TextField
                            label="Amount"
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            fullWidth
                            InputProps={{
                                startAdornment: <InputAdornment position="start">₦</InputAdornment>,
                                sx: { backgroundColor: 'white', flexGrow: 1 }
                            }}
                        />
                        <Button 
                            variant="contained" 
                            color="success" 
                            onClick={() => handlePayment(amount)}
                            disabled={amount < (FIXED_AMOUNT / 2)}
                        >
                            {loading ? <CircularProgress color='inherit' size={10}/> : 'Pay'}
                        </Button>
                    </Box>

                    {paymentUrl && (
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            <Link href={paymentUrl} target="_blank" rel="noopener">
                                {paymentUrl}
                            </Link>
                        </Typography>
                    )}
                </Alert>
            )}


            {project.status === 'CREATED' && project.amount_paid !== 0 && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                    <Typography variant="h6" gutterBottom>
                        Complete Project Details
                    </Typography>
                    <Typography variant="body1" mb={2}>
                        Some project details are missing. Please complete them to proceed.
                    </Typography>
                    <Button 
                        variant="contained" 
                        color="primary"
                        onClick={() => setDrawer({
                            open: true,
                            action: 'UPDATE'
                        })}
                    >
                        Complete Details
                    </Button>
                </Alert>
            )}

            {project.status === 'RUNNING' && project.url && project.url !== 'DEPLOYING' && project.amount_paid < FIXED_AMOUNT && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                    <Typography variant="body1" mb={2}>
                        You can start collecting data but note that you have an outstanding payment 
                        of ₦{(FIXED_AMOUNT - project.amount_paid).toLocaleString()} you 
                        must pay up before you can send your project for analysis.
                    </Typography>
                    <Button 
                        variant="contained" 
                        color="primary"
                        onClick={() => handlePayment(FIXED_AMOUNT - project.amount_paid)}
                    >
                        Pay Up
                    </Button>
                    {paymentUrl && (
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            <Link href={paymentUrl} target="_blank" rel="noopener">
                                {paymentUrl}
                            </Link>
                        </Typography>
                    )}
                </Alert>
            )}

            {project.status === 'COMPLETED' &&
                project.result_url &&
                new Date() - new Date(project.result_updated_at || new Date()) <= 30 * 24 * 60 * 60 * 1000 && (
                    <Alert severity="info" sx={{ mt: 2 }}>
                        <Typography variant="h6" gutterBottom>
                            Disagree with Result?
                        </Typography>
                        <Typography variant="body1" mb={2}>
                            If you believe there is an error with your result, please reach out by raising an issue below.
                        </Typography>
                        <Button 
                            variant="contained" 
                            color="primary"
                            onClick={() => setDrawer({
                                open: true,
                                action: 'REVIEW_REQUEST'
                            })}
                        >
                            Raise Issue
                        </Button>
                    </Alert>
            )}

        </>
    );
}
